import React from 'react';
import { PropTypes } from 'prop-types';
import { t } from '@lingui/macro';
import { Accordion, Button, Flex } from '@decisiv/ui-components';
import { JsonEditor } from 'json-edit-react';

import Copy from '@decisiv/iconix/lib/components/Copy';
import { CODE_EDITOR_THEME } from '../../theme/jsonEditorTheme';
import { DeveloperCodeView } from '../../styles/DeveloperCodeView';
import formatJsonText from '../../utils/formatJsonText';
import formatInputContent from '../../utils/formatInputContent';

import './style.css';

export default function ContentAccordion({ content }) {
  const accordionItems = [
    {
      PanelComponent: () => (
        <Flex id="payloadBox">
          <DeveloperCodeView id="codeBox">
            <JsonEditor
              viewOnly
              rootName=""
              theme={CODE_EDITOR_THEME}
              data={formatInputContent(JSON.parse(content?.input))}
            />
          </DeveloperCodeView>
          <Button
            style={{ borderRadius: '4px' }}
            icon={Copy}
            text={t`Copy`}
            id="copyBtn"
            variant="inverted"
            onClick={() =>
              navigator.clipboard.writeText(formatJsonText(content?.input))
            }
            size="small"
          />
        </Flex>
      ),
      id: 'input-payload',
      title: content?.inputTitle || t`Input`,
    },
    {
      PanelComponent: () => (
        <Flex id="payloadBox">
          <DeveloperCodeView id="codeBox">
            <JsonEditor
              viewOnly
              rootName=""
              theme={CODE_EDITOR_THEME}
              data={JSON.parse(content?.output)}
            />
          </DeveloperCodeView>
          <Button
            icon={Copy}
            text={t`Copy`}
            id="copyBtn"
            variant="inverted"
            onClick={() =>
              navigator.clipboard.writeText(formatJsonText(content?.output))
            }
            size="small"
          />
        </Flex>
      ),
      id: 'output-payload',
      title: content?.outputTitle || t`Output`,
    },
  ];

  return (
    <Accordion
      items={accordionItems}
      titleHeadingLevel="5"
      controls="hide"
      defaultExpanded={['input-payload', 'output-payload']}
      size="large"
    />
  );
}

ContentAccordion.propTypes = {
  content: PropTypes.oneOfType([PropTypes.object]).isRequired,
};
